// extracted by mini-css-extract-plugin
export default {"exContainer":"PageContent_exContainer__ERqCi"};